import React from 'react';
import {itemProps, itemType} from '../structured-data/structuredData';

export function CardPriceComponent({price}) {
    if (price) {
        const {currency, perNight, shortLabel, value} = price;

        return (
            <span className="great-place__card__price" {...itemType('Offer', 'offers')}>
                {itemProps({price: value, priceCurrency: currency})}
                <span className={'great-place__card__price__amount'}>{shortLabel}</span> {perNight}
            </span>
        );
    }
    return null;
}

export default CardPriceComponent;
